/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B010020 受注照会
 */
import { Column, Query } from "@material-table/core";
import {
  B000150TokuiNm2,
  B000151NonyuNm,
  B010020Find,
  B010020FindRequest,
  B010020Get,
  B010020GetCopy,
  B010020GetCopyRequest,
  B010020TogetsuYm,
  B010020Update,
  B010020UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialog,
  SDateField,
  SFrame,
  SLabel,
  SMultiDialog,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  B010020JuchuStatus,
  B010020SyuturyokuKbn,
  getSCode,
  JuchuKbnView,
  JuchuStatus,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import { B000120, B000130, B000140, B000150, B000151, B000202 } from "pages";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { mapIds } from "services";
import { editKbn, juchuStatus } from "services/codes";
import { date, dateWithSlashAt } from "services/DateService";
import { focusState, navigateTypeState, useFocus } from "states";
import { B010010InputData } from "./B010010";

// TODO: メニューから遷移する場合の検索条件、検索結果、ページ数の保持は別途対応していただく
// TODO: version追加（検索時、キャンセル時のマッピングを追加する）

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  juchuStatus: SCode;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  nohinyoteiYmdFrom: string;
  nohinyoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  chumonNo: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  syuturyokuKbn: SCode;
}>;

// テーブルデータ定義
type Data = Partial<{
  gyoNo: number;
  juchuYmd: string;
  juchudenpyoNo: string;
  juchudenpyoNoF: string;
  juchuKbn: string;
  tokuiNm: string;
  nohinyoteiYmd: string;
  shainNm: string;
  juchuKin: string;
  bumonNm: string;
  arariKin: string;
  shukakakuteiKin: string;
  juchuStatusView: string;
  juchuStatus: number;
  version: number;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  juchuYmdFrom: "",
  juchuYmdTo: "",
  seisakuYmdFrom: "",
  seisakuYmdTo: "",
  bumonCdFrom: "",
  bumonCdTo: "",
  juchudenpyoNoFrom: "",
  juchudenpyoNoTo: "",
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  juchuStatus: getSCode(JuchuStatus, "1"),
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
  nohinyoteiYmdFrom: "",
  nohinyoteiYmdTo: "",
  eigyoCdFrom: "",
  eigyoCdTo: "",
  shainCdFrom: "",
  shainCdTo: "",
  chumonNo: "",
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  syuturyokuKbn: getSCode(B010020SyuturyokuKbn, "0"),
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行", width: "4rem" },
  {
    field: "juchuYmd",
    title: "受注日",
    width: "6rem",
    render: (data) => {
      if (data.juchuYmd! !== null && data.juchuYmd! !== "") {
        return dateWithSlashAt(data.juchuYmd!);
      }
    },
  },
  { field: "juchudenpyoNoF", title: "受注伝票番号", width: "7rem" },
  { field: "juchudenpyoNo", hidden: true },
  {
    field: "juchuKbn",
    title: "受注区分",
    width: "4rem",
    render: (data) => {
      return getSCode(JuchuKbnView, data.juchuKbn?.toString() ?? "0")?.label;
    },
  },
  { field: "tokuiNm", title: "得意先", width: "10rem" },
  {
    field: "nohinyoteiYmd",
    title: "必着日",
    width: "6rem",
    render: (data) => {
      if (data.nohinyoteiYmd! !== null && data.nohinyoteiYmd! !== "") {
        return dateWithSlashAt(data.nohinyoteiYmd!);
      }
    },
  },
  { field: "shainNm", title: "受注担当者", width: "8rem" },
  { field: "bumonNm", title: "受注担当部門", width: "6rem" },
  {
    field: "juchuKin",
    title: "受注金額",
    width: "5rem",
    align: "right",
    render: (data) => data.juchuKin?.toLocaleString(),
  },
  {
    field: "arariKin",
    title: "粗利金額",
    width: "5rem",
    align: "right",
    render: (data) => data.arariKin?.toLocaleString(),
  },
  {
    field: "shukakakuteiKin",
    title: "納品済金額　",
    width: "5rem",
    align: "right",
    render: (data) => data.shukakakuteiKin?.toLocaleString(),
  },
  {
    field: "juchuStatusView",
    title: "受注ステータス",
    width: "7rem",
    render: (data) => {
      return getSCode(B010020JuchuStatus, data.juchuStatus?.toString() ?? "0")
        ?.label;
    },
  },
  { field: "juchuStatus", hidden: true },
  { field: "version", hidden: true },
];

// 検索条件を格納するデータタイプ
type SearchedFields = {
  searched: boolean;
} & Partial<{
  fields: Fields;
}>;

// 検索条件を格納するステート
export const B010020State = atom<SearchedFields>({
  key: "B010020State",
  default: {
    searched: false,
    fields: defaultFields,
  },
});

// フォーカスIDの設定
const focusId = "B010020";

export const B010020 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  const [searchedFeields, setSearchedFields] = useRecoilState(B010020State);

  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();

  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);

  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));

  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移の処理
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // 初期表示イベント
  useEffect(() => {
    if (menuNavigate === "menu") {
      // 通常の初期表示時の処理を記載する。
      // 初回フォーカス先
      // システムマスタの当月の初日
      (async () => {
        await B010020TogetsuYm(methods, navigate, setMsg);
        methods.setValue("juchuYmdTo", date());
        focus(1);
      })();
      return;
    }
    if (searchedFeields.searched) {
      // 検索条件が保存されている
      const fields = searchedFeields.fields;
      if (typeof fields !== "undefined") {
        methods.setValue("juchuYmdFrom", fields.juchuYmdFrom);
        methods.setValue("juchuYmdTo", fields.juchuYmdTo);
        methods.setValue("seisakuYmdFrom", fields.seisakuYmdFrom);
        methods.setValue("seisakuYmdTo", fields.seisakuYmdTo);
        methods.setValue("bumonCdFrom", fields.bumonCdFrom);
        methods.setValue("bumonCdTo", fields.bumonCdTo);
        methods.setValue("juchudenpyoNoFrom", fields.juchudenpyoNoFrom);
        methods.setValue("juchudenpyoNoTo", fields.juchudenpyoNoTo);
        methods.setValue("tokuiCd", fields.tokuiCd);
        methods.setValue("tokuishitenCd", fields.tokuishitenCd);
        methods.setValue("tokuiNm", fields.tokuiNm);
        methods.setValue("juchuStatus", fields.juchuStatus);
        methods.setValue("shodaibun", fields.shodaibun);
        methods.setValue("shochubun", fields.shochubun);
        methods.setValue("shoshobun", fields.shoshobun);
        methods.setValue("nohinyoteiYmdFrom", fields.nohinyoteiYmdFrom);
        methods.setValue("nohinyoteiYmdTo", fields.nohinyoteiYmdTo);
        methods.setValue("eigyoCdFrom", fields.eigyoCdFrom);
        methods.setValue("eigyoCdTo", fields.eigyoCdTo);
        methods.setValue("shainCdFrom", fields.shainCdFrom);
        methods.setValue("shainCdTo", fields.shainCdTo);
        methods.setValue("chumonNo", fields.chumonNo);
        methods.setValue("nonyuCd", fields.nonyuCd);
        methods.setValue("nonyushitenCd", fields.nonyushitenCd);
        methods.setValue("nonyuNm", fields.nonyuNm);
        methods.setValue("syuturyokuKbn", fields.syuturyokuKbn);
        setSearched(true);
        return;
      }
    }
  }, []);

  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();

  // selectboxで選択された行のデータ
  const [selectedData, setSelectedData] = useState<Data[]>([]);

  // ボタンの活性・非活性
  const [disabledJuchuCancel, setDisabledJuchuCancel] = useState(true);
  const [disabledJuchuCopy, setDisabledJuchuCopy] = useState(true);
  const [disabledJuchuDetail, setDisabledJuchuDetail] = useState(true);

  // テーブル行選択時
  const handleSelectTableRow = (_: any, rowData: Data | undefined) => {
    // 行が選択されていないときはボタン非活性
    const disabled = typeof rowData === "undefined";
    setDisabledJuchuCopy(disabled);
    setDisabledJuchuDetail(disabled);
    // データを保存
    setRowData(rowData);
  };

  // テーブル行ダブルクリック時・詳細ボタンクリック時
  const handleDoubleClickTableRow = (data: Data) => {
    // 受注データの検索を行う
    B010020Get({ juchudenpyoNo: data.juchudenpyoNo })
      .then((value) => {
        // 確定済・キャンセル済のデータ→参照モード それ以外→編集モード
        const inputData: B010010InputData = {
          editKbn: editKbn.reference,
          juchu: value.data,
        };
        if (data.juchuStatus === juchuStatus.juchuRegistered) {
          inputData.editKbn = editKbn.update;
        }
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 受注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b010010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  //詳細ボタンクリック時
  const handleShowDetail = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }

    // 受注データの検索を行う
    B010020Get({ juchudenpyoNo: rowData.juchudenpyoNo })
      .then((value) => {
        // 確定済・キャンセル済のデータ→参照モード それ以外→編集モード
        const inputData: B010010InputData = {
          editKbn: editKbn.reference,
          juchu: value.data,
        };
        if (rowData.juchuStatus === juchuStatus.juchuRegistered) {
          inputData.editKbn = editKbn.update;
        }
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 受注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b010010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 複製ボタンクリック時 「受注ヘッダのみ」を選択した場合
  const handleClickHeadOnly = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }

    // 選択行の 「juchudenpyoNo」と「copyKbn = 1」(ヘッダのみ) をパラメータに/b010020/get/copy を呼び出す
    const param: B010020GetCopyRequest = {
      juchudenpyoNo: rowData.juchudenpyoNo,
      copyKbn: "1",
    };
    B010020GetCopy(param)
      .then((value) => {
        const inputData: B010010InputData = {
          editKbn: editKbn.register,
          juchu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 受注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b010010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 複製ボタンクリック時 「受注ヘッダ + 受注明細」を選択した場合
  const handleClickAll = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }

    // 選択行の 「juchudenpyoNo」と「copyKbn = 0」(すべて) をパラメータに/b010020/get/copy を呼び出す。
    const param: B010020GetCopyRequest = {
      juchudenpyoNo: rowData.juchudenpyoNo,
      copyKbn: "0",
    };
    B010020GetCopy(param)
      .then((value) => {
        const inputData: B010010InputData = {
          editKbn: editKbn.register,
          juchu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 受注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b010010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行チェックボックス選択時
  const handleCheckTableRow = (data: Data[]) => {
    // 行が選択されている場合のみ実行する。
    const disabled = data.length <= 0;
    setDisabledJuchuCancel(disabled);
    setSelectedData(data);
  };

  // 受注キャンセルイベント
  const handleCancel = () => {
    // リクエスト作成
    const param: B010020UpdateRequest = {
      b010020UpdateFiledList: selectedData.map((value) => {
        return {
          juchudenpyoNo: value.juchudenpyoNo,
          version: value.version,
        };
      }),
    };
    // API呼び出し
    B010020Update(param)
      .then(() => {
        //テーブル更新の為再検索
        (tableRef.current as any).onQueryChange();
        // ボタン非活性化
        setDisabledJuchuCancel(true);
        // 選択されているデータを空にする
        setSelectedData([]);
        // 完了メッセージ
        setMsg(getClientMessage("B010020_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);

  // 検索時の初期化処理
  const handleResetSearch = () => {
    // ボタン非活性化
    setDisabledJuchuCancel(true);
    setDisabledJuchuCopy(true);
    setDisabledJuchuDetail(true);
    // 選択されているデータを空にする
    setRowData({});
    setSelectedData([]);
    (tableRef.current as any).handleClearSelect();
  };

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 初期化
    handleResetSearch();
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 出力順の値に応じたソート処理
      let order;
      if (fields.syuturyokuKbn?.value === "0") {
        order = ["juchuYmd,asc", "juchudenpyoNo,asc"];
      } else if (fields.syuturyokuKbn?.value === "1") {
        order = ["shukayoteiYmd,asc", "juchudenpyoNo,asc"];
      } else if (fields.syuturyokuKbn?.value === "2") {
        order = ["tokuiCd,asc", "tokuishitenCd,asc", "juchudenpyoNo,asc"];
      } else if (fields.syuturyokuKbn?.value === "3") {
        order = ["juchudenpyoNo,asc"];
      }

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B010020FindRequest = {
        juchuYmdFrom: fields.juchuYmdFrom,
        juchuYmdTo: fields.juchuYmdTo,
        seisakuYmdFrom: fields.seisakuYmdFrom,
        seisakuYmdTo: fields.seisakuYmdTo,
        bumonCdFrom: fields.bumonCdFrom,
        bumonCdTo: fields.bumonCdTo,
        juchudenpyoNoFrom: fields.juchudenpyoNoFrom,
        juchudenpyoNoTo: fields.juchudenpyoNoTo,
        tokuiCd: fields.tokuiCd,
        tokuishitenCd: fields.tokuishitenCd,
        juchuStatus: fields.juchuStatus?.value,
        shodaibun: fields.shodaibun,
        shochubun: fields.shochubun,
        shoshobun: fields.shoshobun,
        nohinyoteiYmdFrom: fields.nohinyoteiYmdFrom,
        nohinyoteiYmdTo: fields.nohinyoteiYmdTo,
        eigyoCdFrom: fields.eigyoCdFrom,
        eigyoCdTo: fields.eigyoCdTo,
        shainCdFrom: fields.shainCdFrom,
        shainCdTo: fields.shainCdTo,
        chumonNo: fields.chumonNo,
        nonyuCd: fields.nonyuCd,
        nonyushitenCd: fields.nonyushitenCd,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        // ["出力項目名,順番(asc/desc", ...]
        sort: order,
      };
      // API呼び出し
      B010020Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  //商品中分類が入力されているかどうか
  const existShochubun: boolean = methods.watch("shochubun") !== "";
  //商品小分類が入力されているかどうか
  const existShoshobun: boolean = methods.watch("shoshobun") !== "";

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="受注照会"
        gridTemplateColumns="7rem 3rem 3rem 5rem 1rem 11rem 5rem 6rem 5rem 1rem 11rem"
      >
        <SLabel>受注日</SLabel>
        <SDateField name="juchuYmdFrom" {...register(1)} gridColumn="span 3" />
        <SText>～</SText>
        <SDateField name="juchuYmdTo" {...register(2)} />
        <SLabel>必着日</SLabel>
        <SDateField
          name="nohinyoteiYmdFrom"
          {...register(15)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SDateField name="nohinyoteiYmdTo" {...register(16)} />
        <SLabel gridColumn="1">製作日</SLabel>
        <SDateField
          name="seisakuYmdFrom"
          {...register(3)}
          gridColumn="span 3"
        />
        <SText>～</SText>
        <SDateField name="seisakuYmdTo" {...register(4)} />
        <SLabel>営業所</SLabel>
        <SNumberField
          name="eigyoCdFrom"
          code
          size={6}
          {...register(17)}
          gridColumn="span 2"
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdFrom", data.eigyoCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="eigyoCdTo"
          code
          size={6}
          {...register(18)}
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdTo", data.eigyoCd);
          }}
        />
        <SLabel gridColumn="1">受注担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          {...register(5)}
          gridColumn="span 3"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          {...register(6)}
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
          }}
        />
        <SLabel>受注担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          {...register(19)}
          gridColumn="span 2"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          {...register(20)}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
          }}
        />
        <SLabel gridColumn="1">受注No</SLabel>
        <SNumberField
          name="juchudenpyoNoFrom"
          code
          size={10}
          {...register(7)}
          gridColumn="span 3"
        />
        <SText>～</SText>
        <SNumberField name="juchudenpyoNoTo" code size={10} {...register(8)} />
        <SLabel>客先No</SLabel>
        <STextField
          name="chumonNo"
          code
          size={11}
          {...register(21)}
          gridColumn="span 2"
        />
        <SLabel gridColumn="1">得意先</SLabel>
        <SNumberField
          name="tokuiCd"
          code
          size={6}
          {...register(9)}
          gridColumn="span 2"
          onBlur={() => B000150TokuiNm2(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuishitenCd"
          code
          size={4}
          {...register(10)}
          onBlur={() => B000150TokuiNm2(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCd", data.tokuiCd);
            methods.setValue("tokuishitenCd", data.tokuishitenCd);
            methods.setValue("tokuiNm", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNm" size={40} disabled gridColumn="span 2" />
        <SLabel>納入先</SLabel>
        <SNumberField
          name="nonyuCd"
          code
          size={6}
          {...register(22)}
          onBlur={() => B000151NonyuNm(methods, navigate, setMsg)}
        />
        <SNumberField
          name="nonyushitenCd"
          code
          size={4}
          {...register(23)}
          onBlur={() => B000151NonyuNm(methods, navigate, setMsg)}
          dialog={<B000151 />}
          handleSubmit={(data: any) => {
            methods.setValue("nonyuCd", data.nonyuCd);
            methods.setValue("nonyushitenCd", data.nonyushitenCd);
            methods.setValue("nonyuNm", data.tokuiNmr);
          }}
        />
        <STextField name="nonyuNm" size={40} disabled gridColumn="span 2" />
        <SLabel gridColumn="1">受注ステータス</SLabel>
        <SCodeSelect
          name="juchuStatus"
          options={JuchuStatus}
          {...register(11)}
          gridColumn="span 3"
        />
        <SLabel gridColumn={7}>出力順</SLabel>
        <SCodeSelect
          name="syuturyokuKbn"
          options={B010020SyuturyokuKbn}
          {...register(24)}
          gridColumn="span 2"
        />
        <SLabel gridColumn="1">商品分類</SLabel>
        <SNumberField
          label="商品大分類"
          name="shodaibun"
          code
          size={3}
          {...register(12)}
          required={existShochubun}
        />
        <SNumberField
          label="商品中分類"
          name="shochubun"
          code
          size={3}
          {...register(13)}
          required={existShoshobun}
        />
        <SNumberField
          name="shoshobun"
          code
          size={3}
          {...register(14)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            if (data.shochubun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", "");
              methods.setValue("shoshobun", "");
            } else if (data.shoshobun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", "");
            } else {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", data.shoshobun);
            }
          }}
        />
        <SNormalButton
          label={labels.buttons.search}
          onClick={handleClickSearchButton}
          gridRow={8}
          gridColumn={11}
          {...register(25)}
          align="right"
        />
      </SFrame>
      <SFrame>
        <SText></SText>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          onRowClick={handleSelectTableRow}
          onSelectionChange={handleCheckTableRow}
          onPageChange={handleResetSearch}
          width={1280}
          height={340}
          multi
          handleSetDisabled={(rowData) =>
            rowData.juchuStatus === juchuStatus.cancelFixed
          }
        />
      </SFrame>
      <SFrame gridTemplateColumns="7rem 64.8rem 4rem 4rem">
        {" "}
        <SCancelButton
          label={labels.buttons.juchuCancel}
          gridColumn={1}
          {...register(26)}
          disabled={disabledJuchuCancel}
          dialog={
            <SConfirmDialog
              title="受注キャンセル"
              msg="選択中の受注データをキャンセルします。よろしいですか？"
            />
          }
          dialogAction="confirm"
          handleSubmit={handleCancel}
        />
        <SNormalButton
          label={labels.buttons.copy}
          gridColumn={3}
          {...register(26)}
          disabled={disabledJuchuCopy}
          dialog={
            <SMultiDialog
              title="受注データ複製"
              msg="新規作成する受注データに引き継ぐ対象を選択してください。"
              events={[
                {
                  label: "受注ヘッダのみ",
                  handleSubmit: handleClickHeadOnly,
                },
                {
                  label: "受注ヘッダ+受注明細",
                  handleSubmit: handleClickAll,
                },
              ]}
            />
          }
          dialogAction="close"
        />
        <SNormalButton
          label={labels.buttons.detail}
          gridColumn={4}
          {...register(27)}
          onClick={handleShowDetail}
          disabled={disabledJuchuDetail}
          align="right"
        />
      </SFrame>
    </FormProvider>
  );
};
